import React from 'react';
import {FatOutlineButton} from './FatOutlineButton';


type GreenOutlineButtonProps = {
    onClick?: () => void;
    type?: 'submit' | 'reset' | 'button';
    disabled?: boolean;
    text: string;
}
export const FatGreenOutlineButton = ({text, onClick, type = 'button', disabled = false}: GreenOutlineButtonProps) => {
    return <FatOutlineButton text={text} onClick={onClick} type={type} color="green" disabled={disabled}/>;
}
